import React from "react";
import first from "lodash/first";
import moment from "moment";

import { Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { Stop } from "types";
import { useTimeFormat } from "globals/hooks";

function PickupTimeColumn(props: GridRenderCellParams<string>) {
  const { row } = props;
  const { formatTime } = useTimeFormat();

  const pickupStop = first(row.stops as unknown as Stop[]);

  const timezone = pickupStop.timezoneId || moment.tz.guess();
  const timeWithTimezone = moment.tz(pickupStop.dateTime, timezone);
  const offset = timeWithTimezone.utcOffset();

  const adjustedTime = timeWithTimezone.add(-1 * (offset / 60), "hour");
  const displayTime = `${formatTime(adjustedTime)} ${adjustedTime.format("z")}`;

  return <Typography variant="body2">{displayTime}</Typography>;
}

export default PickupTimeColumn;
